import { VendorsEditForm } from 'application/vendors/forms';
import { BaseEditViewStore } from 'core/stores';
import { applicationContext } from 'core/utils';
import { VendorsService } from 'application/vendors/services';
import { action } from 'mobx';

@applicationContext
class VendorsEditViewStore extends BaseEditViewStore {
    constructor(rootStore) {
        const id = rootStore.routerStore.routerState.params.id;
        const service = new VendorsService(rootStore.application.baasic.apiClient);

        super(rootStore, {
            name: 'vendors',
            id: id,
            Form: VendorsEditForm,
            authorization: 'portalSection.update',
            actions: () => {
                return {
                    get: async (id, opts) => {
                        const response = await service.get(id, opts);
                        return response.data;
                    },
                    update: async (resource) => {
                        const response = await service.update(resource);
                        return response.data;
                    },
                    create: async (resource) => {
                        const response = await service.create(resource);
                        return response.data;
                    }
                }
            },
            FormClass: VendorsEditForm,
        });
    }

    onCreateError(err) {
        if (!this.errorActions.onCreateError) {
            this.rootStore.notificationStore.error(
                err && err.data && err.data.message ? err.data.message === 'The request is invalid.' ? 'This Vendor already exists.' : err.data.message : `Error occurred while trying to update a Vendor.`
            );
            return;
        }
        return this.errorActions.onCreateError(err)
    }

    onUpdateError(err) {
        if (!this.errorActions.onUpdateError) {
            this.rootStore.notificationStore.error(
                err && err.data && err.data ? err.data : `Error occurred while trying to update a Vendor.`
            );
            return;
        }
        return this.errorActions.onUpdateError(err);
    }

    @action.bound
    notifySuccessCreate() {
        this.rootStore.notificationStore.success('VENDORS.CREATE.SUCCESS_CREATE');
    }

    @action.bound
    notifySuccessUpdate(name) {
        this.rootStore.notificationStore.success('VENDORS.EDIT.SUCCESS_UPDATE', name);
    }
}

export default VendorsEditViewStore;
